import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { Provider } from 'react-redux'
import store from './store'
import theme from './theme'
import { ThemeProvider } from 'styled-components'
import { ThemeContextProvider } from './contexts/ThemeContext'
import { initSentry } from './lib/sentry'
import ErrorFallback from './components/common/ErrorFallback'
import * as Sentry from '@sentry/react'
import './i18n'

initSentry()

ReactDOM.render(
  <Sentry.ErrorBoundary fallback={ErrorFallback}>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ThemeContextProvider>
          <App />
        </ThemeContextProvider>
      </ThemeProvider>
    </Provider>
  </Sentry.ErrorBoundary>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
